export default "__VITE_ASSET__DgT8pMp7__"